module.exports = __webpack_public_path__ + "static/img/logoutPageIcon.3d013d2f.svg";